// @flow
import {connect} from "react-redux";
import type {StoreState} from "../../reducers/combinedReducers";
import type {BootstrapDispatchProps, BootstrapStateProps} from "../../components/app/Bootstrap";
import Bootstrap from "../../components/app/Bootstrap";
import type {BootstrapAction} from "../../actions/app/bootstrapAction";
import {appBootstrapAction} from "../../actions/app/creators/bootstrapActionCreator";

/**
 * Created by Mike Chung on 2/9/18.
 */
const mapStateToProps = (state: StoreState): BootstrapStateProps => {

    return {
        complete: state.bootstrap.complete,
        error: state.bootstrap.error
    };
};

const mapDispatchToProps = (dispatch: (action: BootstrapAction) => any): BootstrapDispatchProps => {
    return {
        bootstrapApp: () => {
            dispatch(appBootstrapAction());
        }
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(Bootstrap);



// WEBPACK FOOTER //
// ./src/containers/app/Bootstrap.js